<div class="detail-page-card">
    <div class="detail-page-card-title">Comments</div>
    <div class="detail-page-card-body">
        @if (isLoading) {
            <div class="fancy-loader submodule my-4"></div>
        } @else {
            @if (comments && comments.length > 0) {
                <div class="comments">
                    <div class="row headers">
                        <div class="col-5">Comment</div>
                        <div class="col">Type</div>
                        <div class="col">User</div>
                        <div class="col">Date</div>
                    </div>

                    @for (comment of scopedComments; track comment) {
                        <div class="row comment-row">
                            <div class="col-5">
                                @if (comment.comment) {
                                    <span>{{ comment.comment }}</span>
                                } @else {
                                    <i style="font-size: 0.8em">* No comment given.</i>
                                }
                            </div>
                            <div class="col">{{ comment.commentType }}</div>
                            <div class="col">{{ comment.createdBy }}</div>
                            <div class="col">{{ comment.createdAt | dateFormat }}</div>
                        </div>
                    }
                </div>
            } @else {
                <div class="no-comments">There are no comments available yet.</div>
            }
            @if (comments && comments.length > 5) {
                <div class="more-comments" (click)="showAllClick(!showAll)">
                    View {{ showAll ? "last 5 " : "all " + comments.length }} comments
                </div>
            }
        }
    </div>
</div>
